jQuery_T4NT(document).ready(function($) {
    /**
    *  Variant selection changed
    *  data-variant-toggle="{{variant.id}}"
    */
    $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
      });
	});

    // Collection Pages - Read More/Less Function
    // Hide the extra content initially, using JS so that if JS is disabled, no problemo:
    $('.read-more-content').addClass('hide')
    $('.read-more-show, .read-more-hide').removeClass('hide')

    // Set up the toggle effect:
    $('.read-more-show').on('click', function(e) {
      $(this).next('.read-more-content').removeClass('hide');
      $(this).addClass('hide');
      e.preventDefault();
    });

    // Changes contributed by @diego-rzg
    $('.read-more-hide').on('click', function(e) {
      var p = $(this).parent('.read-more-content');
      p.addClass('hide');
      p.prev('.read-more-show').removeClass('hide'); // Hide only the preceding "Read More"
      e.preventDefault();
    });

    // Read More / Less Function in Homepage SEO Description
    function moreFunction() {
      var lessText = document.getElementById("showless");
      var moreText = document.getElementById("showmore");
      var btnText = document.getElementById("readBtn");

      if (showless.style.display === "none") {
        showless.style.display = "inline";
        btnText.innerHTML = "Read more"; 
        moreText.style.display = "none";
      } else {
        showless.style.display = "none";
        btnText.innerHTML = "Read less"; 
        moreText.style.display = "inline";
      }
    };
